import { css, StyleDeclarationValue } from 'aphrodite';
import { bs } from '../../styles/styles';
import { XIcon } from '../svgs/icons/XIcon';

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	styles?: StyleDeclarationValue[];
	fillColor?: string;
	size?: number;
}

export function CloseButton({ styles = [], fillColor, size = 14, ...props }: IProps) {
	return (
		<button data-testid='close-button' className={css(bs.px3, bs.py2, ...styles)} {...props}>
			<XIcon width={size} height={size} color={fillColor} />
		</button>
	);
}
